// Helper function to parse Excel dates
const parseExcelDate = (excelDate) => {
  // If the cell is a date serial number, Excel uses 1900 as its base date
  const baseDate = new Date(1899, 11, 30); // Excel dates start at 1900-01-01, adjust with this base
  return new Date(baseDate.getTime() + excelDate * 86400000); // Convert serial number to JavaScript date
};

export default parseExcelDate;
